<template>
    <div>
        <h1>Activate Return-Shop</h1>

        <v-stepper v-model="cur" vertical>
            <v-stepper-step step="1" :complete="cur > 1" editable>
                Select Customer

                <small v-if="customer">
                    {{customer.customerName1}} {{customer.customerName2}} {{customer.customerName3}}
                </small>
            </v-stepper-step>
            <v-stepper-content step="1">
              <v-autocomplete
                v-model="customer"
                :search-input.sync="customerSearchInput"
                item-text="customerName1"
                item-value="id"
                filled
                :items="customerAutocompleteData"
                return-object
              >
              </v-autocomplete>

              <v-btn @click.native="updateCustomer()" block color="success" v-if="customer" >Next</v-btn>
            </v-stepper-content>


            <v-stepper-step step="2" editable>
                Branding

                <small v-if="brandName">
                  {{brandName}}
                </small>
            </v-stepper-step>
            <v-stepper-content step="2">
              <v-container fluid>
              <v-layout row class="pb-4">
                <v-flex xs16>
                  <v-text-field
                    prepend-icon="http"
                    ref="step1_text-field"
                    :rules="[rules.required, rules.greater3, rules.sanitized]"
                    v-model="dirtyIdentifier"
                    @input="checkIndentifierAvailbility"
                    counter="50"
                    filled
                    label="Identifier"
                    placeholder="Enter here the identifier of your return shop"
                    :hint="consumerAppUrlPreview(identifier)"
                    persistent-hint
                    id="testing"
                    :error="false"
                    :error-messages="identifierErrorArr"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs16>
                  <v-text-field
                  prepend-icon="business"
                  ref="step3_text-field"
                  :rules="[rules.required, rules.greater3]"
                  v-model="brandName"
                  label="Brand Name"
                  filled
                  placeholder="This is the name of your brand which will be used in Text-Modules in the App and in E-Mails."
                  id="testing"
                ></v-text-field>
                </v-flex>
              </v-layout>
              <v-btn @click.native="updateBranding()" block color="success" v-if="identifier && brandName && !hasError" >Next</v-btn>
            </v-container>
            </v-stepper-content>


            <v-stepper-step step="3">Configuration</v-stepper-step>
            <v-stepper-content step="3">

              <isrs-parcel-number-select
                :parcelnumbercontainers="parcelnumbercontainers"
                @change="id => updateParcelNumberContainerId(id)"
              ></isrs-parcel-number-select>

              <h4>Country Mappings</h4>

              <div>

                <v-layout ma-2 row wrap v-for="contact in contacts" :key="contact.contactId">
                  <v-flex xs8>
                    <v-select
                      :items="countries"
                      v-model="countriesSelected[contact.contactId]"
                      label="Customers from these countries:"
                      item-text="name"
                      item-value="alpha2"
                      multiple
                    ></v-select>
                  </v-flex>

                  <v-flex xs2 ml-4>
                    <small class="grey--text text--darken-2">send returns to this contact:</small>
                    <div>
                      Contact ID:<b> {{contact.contactId}}</b>
                    </div>
                    <hr style="height:1px;border:none;background-color:grey;" />
                    <div>
                      <b>{{contact.contactText1}} {{contact.contactText2}} {{contact.contactText3}}</b>
                    </div>
                    <div>
                      <i>{{contact.street}}</i>
                    </div>
                    <div>
                      <i>{{contact.zipcode}} {{contact.city}}</i>
                    </div>
                  </v-flex>
                </v-layout>

                <v-layout row wrap ma-2>
                  <v-flex xs12>
                    The following countries are not mapped and therefore customers from these countries can not send a return to this customer:
                    <span>
                      {{notMappedCountries.map(c => c.name).join(", ")}}
                    </span>
                  </v-flex>
                </v-layout>
                </div>

                <v-btn @click.native="publishReturnShop()" block color="success" v-if="payload && !publishError">Publish</v-btn>

                <v-alert type="error" v-if="this.publishError.length > 1">
                  {{publishError}}
                </v-alert>
              </v-container>
            </v-stepper-content>
        </v-stepper>
    </div>
</template>

<script>
import DataService from '../../services/data'
import IsrsParcelNumberSelect from '../../components/IsrsParcelNumberSelect.vue'

import { mapState } from 'vuex'

export default {
  components: {
    IsrsParcelNumberSelect
  },

  data() {
    return {
      cur: undefined,
      customer: undefined,
      customerLoading: false,
      customerSearchInput: '',
      customerAutocompleteData: [],
      contacts: [],
      rules: {
        required: val => !!val || 'Required.',
        sanitized: val =>
          !!val.match(/^[a-z-0-9]+$/) || 'Value must be greater than 3 characters and only in small letters or numbers or with a hypen [ allowed characters: a-z, 0-9, -] ',
        greater3: val => val.length >= 3 || 'Value must be greater than 3 characters.'
      },
      dirtyIdentifier: '',
      identifierError: '',
      identifier: '',
      consumer_app_url: '',
      brandName: '',
      countriesSelected: {},
      countryContactMapping: {},
      parcelnumbercontainers: [],
      selectedParcelNumberContainer: undefined,
      publishError: '',
      hasError: false
    }
  },

  computed: {
    ...mapState({
      countries: state => state.config.countries
    }),
    countryMap() {
      return this.countries.reduce((acc, cur) => {
        acc[cur.name] = undefined
        console.log('ACC:', acc)
        return acc
      }, {})
    },

    notMappedCountries() {
      const selectedCountries = Object.values(this.countriesSelected).reduce(
        (acc, cur) => acc.concat(cur),
        []
      )

      return this.countries.filter(item => {
        return !selectedCountries.includes(item.alpha2)
      })
    },

    countryContactMappings() {
      return Object.entries(this.countriesSelected)
        .map(([contactId, countries]) => {
          return countries.map(country => ({
            destinationContactId: contactId,
            originCountry: country
          }))
        })
        .reduce((acc, cur) => acc.concat(cur), [])
    },

    identifierErrorArr() {
      return !!this.identifierError ? [this.identifierError] : undefined
    },

    payload() {
      const customerId = this.customer && this.customer.customerId
      const identifier = this.identifier
      const brandName = this.brandName
      const parcelNumberContainerId = this.selectedParcelNumberContainer
      const countryContactMappings = this.countryContactMappings
      const regex = /^[a-z-0-9]+$/
      this.hasError = false

      if((this.brandName && this.identifier) && (!regex.test(this.identifier) || this.brandName.length <= 3)) {
        this.hasError = true;
      }

      console.log('!!', {
        customerId,
        identifier,
        brandName,
        parcelNumberContainerId,
        countryContactMappings
      })

      if (
        (customerId && identifier && brandName && parcelNumberContainerId,
        countryContactMappings.length)
      ) {
        return {
          customerId,
          identifier,
          config: { brandName },
          parcelNumberContainerId,
          countryContactMappings
        }
      }
    }
  },

  created() {
    this.dataService = new DataService(this.profile, this.$store.state.tokens)

    if (this.$route.params.customerId) {
      this.loadCustomer(this.$route.params.customerId)
        .then(() => {
          //this.cur = 2
        })
        .then(() => {
          const { identifier, brandName } = this.$route.query

          if (identifier && brandName) {
            this.identifier = identifier
            this.brandName = brandName
            this.cur = 3
          } else {
            this.cur = 2
          }
        })
    }
  },

  watch: {
    customerSearchInput(val) {
      if (val) {
        this.dataService
          .searchCustomers(val)
          .then(result => result.data)
          .then(data => {
            this.customerAutocompleteData = data.content
          })
      }
    }
  },

  methods: {
    consumerAppUrlPreview(identifier) {
      return `${this.consumer_app_url}/#/m/${identifier}`
    },

    loadCustomer(customerId) {
      return this.dataService
        .getCustomer(customerId)
        .then(result => result.data)
        .then(data => {
          this.customer = data
          this.customerAutocompleteData = [data]

          return this.dataService
            .getCustomerContacts(customerId)
            .then(result => result.data)
        })
        .then(data => {
          this.contacts = data.content
        })
        .then(() => {
          return this.loadParcelNumberContainers()
        })
    },

    loadParcelNumberContainers() {
      console.log('customer', this.customer)
      return this.dataService
        .getCustomerParcelNumberContainerByUuid(this.customer.customerId)
        .then(result => {
          this.parcelnumbercontainers = result.data
        })
    },

    updateCustomer() {
      this.loadCustomer(this.customer.customerId).then(() => {
        this.$router.push(
          `/returnshopportals/activate/${this.customer.customerId}`
        )
        this.cur = 2
      })
    },

    updateBranding() {
      const { identifier, brandName } = this

      this.$router.replace({ query: { identifier, brandName } })
      this.cur = 3

      // TODO: Load parcel number containers

      //
    },

    publishReturnShop() {
      this.dataService
        .publishReturnShop(this.payload)
        .then(data => {
          this.$router.push(`/returnshopportals/${this.identifier}`)
        })
        .catch(err => {
          if (err.response.data.message) {
            this.publishError = err.response.data.message
          } else {
            this.publishError = 'Unable to publish return-shop ' + err
          }
        })
    },

    checkIndentifierAvailbility: _.debounce(function(val) {
      console.log('checkIndentifierAvailbility', val)

      this.dataService
        .checkIdentifierAvailbility(val)
        .then(result => result.data)
        .then(data => {
          console.log('DATA:', data)
          this.identifier = val
          this.identifierError = ''
        })
        .catch(err => {
          this.identifier = ''
          this.identifierError = `The identifier ${val} is not available.`
        })
    }, 400),

    updateParcelNumberContainerId(parcelNumberContainerId) {
      this.selectedParcelNumberContainer = parcelNumberContainerId
    }
  }
}
</script>



// WEBPACK FOOTER //
// Activate.vue?48b2fa62